import { api } from '../../../lib/api'

export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST'
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS'
export const DELETE_NOTIFICATION_FAILED = 'DELETE_NOTIFICATION_FAILED'

export const deleteNotification = (notificationId) => {
  return function (dispatch) {
    dispatch({
      type: DELETE_NOTIFICATION_REQUEST
    })
    api.deleteNotification(notificationId).then(deleteNotificationResponse => {
      dispatch({
        type: DELETE_NOTIFICATION_SUCCESS,
        payload: deleteNotificationResponse
      })
    }).catch(error => {
      dispatch({
        type: DELETE_NOTIFICATION_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification/delete-notification.js